
















import { Component, Prop, Vue } from 'vue-property-decorator';
import shapes from '@/assets/leg-shape-guide.json';

@Component({})
export default class LegShapeGuideModal extends Vue {
	@Prop({ required: true, type: String })
	public modalId!: string;

	public readonly shapes = shapes;
}
